module.exports = __webpack_public_path__ + "img/panelView_blackBg_3_3.049d6f5c.png";